module.exports = __webpack_public_path__ + "img/buddy_eyes-04.a48e8bbc.svg";